import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserService } from '../../user/user.service';
import { switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-create-version-modal',
  templateUrl: './create-version-modal.component.html',
  styleUrls: ['./create-version-modal.component.scss'],
})
export class CreateVersionModalComponent implements OnInit, OnDestroy {
  constructor(
    private userService: UserService,
    private cdr: ChangeDetectorRef,
  ) {}
  adminArray: any = [];
  selectedAdmin: number;
  @ViewChild('createVersionModal', { static: true }) public createVersionModal: ModalDirective;
  @Output() create = new EventEmitter<any>();
  @Output() previewLetter = new EventEmitter<any>();
  @Input() isPreviewLetter: boolean;

  private subscription: Subscription;

  async ngOnInit(): Promise<void> {
    this.subscription = this.userService
      .listAdminWithRecletter()
      .pipe(
        switchMap((res: any) => {
          this.adminArray = res;
          return this.userService.profile();
        }),
      )
      .subscribe((currentUser: any) => {
        if (currentUser) {
          this.selectedAdmin = this.adminArray.find(u => u.id == currentUser.id)?.id;
        }
        this.cdr.detectChanges();
      });
  }

  async show() {
    this.createVersionModal.show();
  }

  cancel() {
    this.createVersionModal.hide();
  }

  createVersion() {
    this.create.emit(this.selectedAdmin);
    this.createVersionModal.hide();
  }

  previewRecLetter() {
    this.previewLetter.emit(this.selectedAdmin);
    this.createVersionModal.hide();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
